import { useEffect, useState } from "react";
import GlobalStyles from "@mui/material/GlobalStyles";
import { StyledEngineProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { QueryClientProvider } from "@tanstack/react-query";
import { enUS } from "date-fns/locale";
import { Provider as JotaiProvider, useAtomValue } from "jotai";
import { SnackbarProvider } from "notistack";
import { RouterProvider } from "react-router/dom";
import { AppSnackbarCloseButton } from "src/components/App/components/AppSnackbarCloseButton/AppSnackbarCloseButton.tsx";
import { AppRouterContextProvider } from "src/store/appRouterStore";
import { tokenAtom } from "src/utils/auth/auth-atoms.ts";
import { AppStore } from "src/utils/jotai.ts";
import { queryClient } from "@utils/query-client.ts";
import { router } from "./router.tsx";

const DebugTokenTimeoutFooter = () => {
  const [now, setNow] = useState(Date.now());

  const token = useAtomValue(tokenAtom);
  const expiredIn = token?.exp ? Math.round(token.exp - now / 1000) : null;

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div id="definity-debug-footer" className="fixed bottom-0 right-0 z-30">
      token expires in: {expiredIn}
    </div>
  );
};

const SHOW_DEBUG_FOOTER = false;

const WrappedApp = () => {
  return (
    <StyledEngineProvider enableCssLayer>
      <GlobalStyles styles="@layer theme, base, mui, components, utilities;" />
      <JotaiProvider store={AppStore}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={enUS}
          // dateFormats={{ shortDate: "dd/MM/yyyy" }}
        >
          <SnackbarProvider
            maxSnack={2}
            autoHideDuration={3000}
            action={(snackbarKey) => (
              <AppSnackbarCloseButton snackbarKey={snackbarKey} />
            )}
          >
            <AppRouterContextProvider>
              <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} useTransitions={false} />
                {SHOW_DEBUG_FOOTER && <DebugTokenTimeoutFooter />}
              </QueryClientProvider>
            </AppRouterContextProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </JotaiProvider>
    </StyledEngineProvider>
  );
};

export default WrappedApp;
